import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export type CheckInStatus = "made-it" | "heading-home" | "running-late" | "all-good" | "custom";
export type CheckInLocation = { latitude: number; longitude: number; label?: string };
export type FamilyCheckInEntry = {
  id: string;
  action: "status" | "note" | "request";
  status: CheckInStatus | null;
  message: string;
  location: CheckInLocation | null;
  senderUid: string;
  senderName: string;
  recipientUids: string[];
  replyToId: string | null;
  createdAt: number;
};

type CreateInput = {
  householdId: string;
  action: "status" | "note" | "request";
  status?: CheckInStatus;
  message?: string;
  recipientUids: string[];
  location?: CheckInLocation | null;
  replyToId?: string;
};

type CreateResult = {
  id: string;
  recipients: number;
  registeredDevices: number;
  acceptedDevices: number;
  failedDevices: number;
  pushError?: string;
};

const createCheckIn = httpsCallable<CreateInput, CreateResult>(functions, "createFamilyCheckIn");
const getCheckIns = httpsCallable<{ householdId: string }, { entries: FamilyCheckInEntry[] }>(functions, "getFamilyCheckIns");

function clean(value: string, length: number) {
  return value.replace(/\s+/g, " ").trim().slice(0, length);
}

export async function createFamilyCheckIn(input: CreateInput) {
  return (await createCheckIn({
    ...input,
    message: clean(input.message || "", 180),
    recipientUids: [...new Set(input.recipientUids)]
  })).data;
}

export async function loadFamilyCheckIns(householdId: string) {
  return (await getCheckIns({ householdId })).data.entries;
}

export function checkInMapUrl(location: CheckInLocation) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${location.latitude},${location.longitude}`)}`;
}
